import { render, staticRenderFns } from "./sign-in-banner.vue?vue&type=template&id=2e61a96a&scoped=true&lang=pug&"
import script from "./sign-in-banner.vue?vue&type=script&lang=js&"
export * from "./sign-in-banner.vue?vue&type=script&lang=js&"
import style0 from "./sign-in-banner.vue?vue&type=style&index=0&id=2e61a96a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61a96a",
  null
  
)

component.options.__file = "sign-in-banner.vue"
export default component.exports